import { render } from "./BannerFour.vue?vue&type=template&id=db1c1602"
import script from "./BannerFour.vue?vue&type=script&lang=js"
export * from "./BannerFour.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__